import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef, SimpleChanges } from '@angular/core';
import { EditDetailsAuthorization, ClientAuthorizationBO, functionpermission, IsViewEditSchedule, ServiceDetailBO } from '../client-parent.model';
import { HttpErrorResponse } from '@angular/common/http';
import { GlobalComponent } from 'src/app/global/global.component';
import { IMyDateModel, IMyInputFieldChanged, IMyDpOptions } from 'mydatepicker';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { DatePipe } from '@angular/common';
import { CommonApiService } from 'src/app/commonapiservice';

@Component({
  selector: 'app-client-authorization-edit',
  templateUrl: './client-authorization-edit.component.html',
  styleUrls: ['./client-authorization-edit.component.scss'],
})
export class ClientAuthorizationEditComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  fp: functionpermission
  @Input() DataFromAuthorizationList: EditDetailsAuthorization = new EditDetailsAuthorization();
  @Output() EventToEditAuth = new EventEmitter<EditDetailsAuthorization>();
  today = new Date();
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
    showClearDateBtn: false,
    editableDateField: true
  };
  public myDatePickerOptionsDOB: IMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
    disableSince: { year: this.today.getFullYear(), month: this.today.getMonth() + 1, day: this.today.getDate() + 1 },
    showClearDateBtn: false,
    editableDateField: true
  };
  isEdit: boolean = true;
  isAdd: boolean = true;
  ServiceDropdown: any;
  masterserviceId: any = [];
  companyList: any = [];
  serviceinbox: any = [];
  serviceObjList: any = {};
  updateAuthList: any = new ClientAuthorizationBO();
  getErr_count: string = '';
  grouppayor_serviceDescription: any = [];
  billingvalue: number = 0;
  saveAuthErr: string = "";
  grouppayorServiceArray: any;
  grouppayorServiceArray1: any;
  payorList: [{ Key: string, Value: string }];
  loadingAuthadd: boolean = false;
  loadingAuthupdate: boolean = false;
  @Output() isViewEdit = new EventEmitter<IsViewEditSchedule>();
  ViewEdit: IsViewEditSchedule = { isView: true, isEdit: true, isAdd: true, editScheduleId: 0, AgencyId: "00000000-0000-0000-0000-000000000000", ClientId: "00000000-0000-0000-0000-000000000000", Data: null };
  constructor(public CommonAPI: CommonApiService, private datepipe: DatePipe,  public global: GlobalComponent, public toastrService: ToastrService, private ref: ChangeDetectorRef,
    public ngxservice: NgxUiLoaderService) {
   // this.global.agencyList();
  
  }
  ngOnInit(): void {
    
    
    if (this.DataFromAuthorizationList.type == 'edit') {
      this.updateAuthList = this.DataFromAuthorizationList.AuthorizationData
      this.updateAuthList.startDate = this.datepipe.transform(this.updateAuthList.startDate, "MM/dd/yyy");
      this.updateAuthList.endDate = this.datepipe.transform(this.updateAuthList.endDate, "MM/dd/yyy");
      this.updateAuthList.payerId = (this.updateAuthList.payerId != null) ? this.updateAuthList.payerId.toString() : null;
      this.updateAuthList.companyId = (this.updateAuthList.companyId != null) ? this.updateAuthList.companyId.toString() : null;
      this.grouppayorService(this.updateAuthList, false);
      this.getbillingValue(this.updateAuthList)
      this.updateAuthList.payerServiceMapId = this.updateAuthList.payerServiceMapId.toString();
      this.updateAuthList.DisableAuthorization = this.updateAuthList.disableAuthorization == true ? true : false;
      this.updateAuthList.masterserviceId = (this.updateAuthList.masterserviceId != null && this.updateAuthList.masterserviceId != 0 &&
        this.updateAuthList.masterserviceId != undefined) ? this.updateAuthList.masterserviceId.toString() : 0;
      document.getElementById("editmodelopen").click();
    }
    if (this.DataFromAuthorizationList.type == 'new') {
    
      
      document.getElementById("modelopen").click();
      this.global.clientId = this.DataFromAuthorizationList.ClientId
     

    }
    if (this.DataFromAuthorizationList.type == 'delete') {
      document.getElementById("deletemodal").click();
    }
    if (this.DataFromAuthorizationList.type != 'delete') {
      this.getCompanyList();
      this.getPayorList();
    }
  }
  ngOnChanges(changes: SimpleChanges) {
    // debugger;
    let f = changes;
    this.saveAuthErr = ""
    this.serviceObjList = {};
    this.serviceinbox = [];
    this.global.clientId = this.DataFromAuthorizationList.ClientId
    this.addService();


  }

  //================================Add service===============================//

  addService() {

    this.serviceObjList = {
      id: '00000000-0000-0000-0000-000000000000',
      clientId: this.global.clientId,
      startDate: null,
      endDate: null,
      companyId: null,
      isAdd: true,
      payerId: null,
      insuranceNo: null,
      serviceAgreementNo: null,
      payerServiceMapId: null,
      serviceDescription: null,
      authLimitType: null,
      totalUnits: null,
      unitsUsed: null,
      unitsRemaining: null,
      billingvalue: null,
      ucRate: null,
      netRate: null,
      DisableAuthorization: null,
      grouppayorServiceArray: [],
      masterserviceId: null,
      modifier1:null,
modifier2:null,
modifier3:null,
modifier4:null,
serviceCode:null

    }
    this.serviceinbox.push(this.serviceObjList);
  }
  addSer(i, serviceList: any) {
    if (i >= 0) {
      this.serviceinbox[i].isAdd = false;
    }
    this.serviceObjList = {
      id: '00000000-0000-0000-0000-000000000000',
      clientId: this.global.clientId,
      startDate: serviceList.startDate,
      endDate: serviceList.endDate,
      isAdd: true,
      companyId: serviceList.companyId != null ? serviceList.companyId.toString() : null,
      payerId: serviceList.payerId != null ? serviceList.payerId.toString() : null,
      insuranceNo: serviceList.insuranceNo,
      serviceAgreementNo: serviceList.serviceAgreementNo,
      payerServiceMapId: null,
      serviceDescription: null,
      authLimitType: null,
      totalUnits: null,
      unitsUsed: null,
      unitsRemaining: null,
      billingvalue: null,
      ucRate: null,
      netRate: null,
      DisableAuthorization: null,
      grouppayorServiceArray: serviceList.grouppayorServiceArray,
      masterserviceId: null,
      modifier1:null,
      modifier2:null,
      modifier3:null,
      modifier4:null,
      serviceCode:null
    }
    this.serviceinbox.push(this.serviceObjList);
  }
  ///////////////////////remove added list in auth////////////////
  removeList(i) {
    this.serviceinbox.splice(i, 1);
    var length = this.serviceinbox.length;
    var count = 0;
    this.serviceinbox.forEach(element => {
      if (element.isAdd == false) {
        count++;
      }
    })
    if (length == count) {
      this.serviceinbox[length - 1].isAdd = true;
    }
  }
  ///////////////////////////total hours per day /////////////////////////////////////////
  calculatetotalhour(start, end, unit, i, billingvalue) {

    if (start != null && end != null && unit != null) {
      let diffDays = (Math.round(Math.abs(new Date(end).getTime() - new Date(start).getTime()) / (1000 * 60 * 60 * 24))) + 1;
      let units = unit / diffDays;
      let val = (units / billingvalue).toFixed(2).toString();
      let val2 = val.split('.');
      if (val2.length == 1) {
        this.serviceinbox[i].unitperday = val2[0] + " hr " + "0 Min";
      }
      else {
        let vals2 = 0 + "." + val2[val2.length - 1];
        this.serviceinbox[i].unitperday = val2[0] + " hr " + (parseFloat(vals2) * 60).toString().split('.')[0] + "Min";;


      }

    }
  }
  //====================================Service code update================================//
  serviceCodeUpdate(index, value, status, grouppayorServiceArray) {
    if (status == 'create') {
      if (grouppayorServiceArray.length > 0) {
        let a = grouppayorServiceArray?.filter(a => a.id == value)[0];

        this.serviceinbox[index].masterserviceId = a?.masterserviceid;
        this.serviceinbox[index].modifier1 = a?.modifier1;
        this.serviceinbox[index].modifier2 = a?.modifier2;
        this.serviceinbox[index].modifier3= a?.modifier3;
        this.serviceinbox[index].modifier4= a?.modifier4;
        this.serviceinbox[index].serviceCode= a?.serviceCode;
        console.log(a,"a===================");
        
      }
    }
    else if (status == 'update') {
      if (grouppayorServiceArray.length > 0) {
        let a = grouppayorServiceArray?.filter(a => a.id == value)[0];
        this.updateAuthList.authLimitType = "";
        if (a != null) {
          this.updateAuthList.masterserviceId = a.masterserviceid;

          this.updateAuthList.modifier1 = a?.modifier1;
          this.updateAuthList.modifier2 = a?.modifier2;
          this.updateAuthList.modifier3= a?.modifier3;
          this.updateAuthList.modifier4= a?.modifier4;
          this.updateAuthList.serviceCode= a?.serviceCode;
       
        }

      }
    }
    
    
    if (value != "" && value != undefined && value != null) {
      let params = new URLSearchParams();
      params.append("Id", value.toString());
      let url = "api/ClientAuthorization/GetServiceDescription?";
      this.CommonAPI.GetFunctionwithResponseTypeJson(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        if (index == -1) {
          this.updateAuthList.serviceDescription = data.serviceDescription;
          this.updateAuthList.authLimitType = data.authLimitType;
        }
        else {
          this.serviceinbox[index].serviceDescription = data.serviceDescription;
          this.serviceinbox[index].authLimitType = data.authLimitType;
        }

      });
    }
    else {
      this.serviceinbox[index].serviceDescription = null;
      this.serviceinbox[index].authLimitType = null;
    }
  }
  //========================================get billing value============================//
  getbillingValue(id) {
    if (id != undefined) {
      let params = new URLSearchParams();
      params.append("grouppayor", id.payerServiceMapId.toString());
      let url = "api/ClientAuthorization/GetBilling?";
      this.CommonAPI.GetFunctionwithResponseTypeJson(params,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        id.billingvalue = data;
        if (id.billingvalue == 0) {
          id.billingvalue = 0;
          this.saveAuthErr = "There is no Billing Unit "
        }
        else {
          if (this.updateAuthList.totalUnits != null && this.updateAuthList.totalUnits != undefined && this.updateAuthList.totalUnits != '' && this.updateAuthList.totalUnits != "") {
            this.calculatetotalhour1(this.updateAuthList.startDate, this.updateAuthList.endDate, this.updateAuthList.totalUnits, this.updateAuthList.billingvalue)
          }

        }
      }, (err: any) => {
        if (err) {
          this.getErr_count = JSON.stringify(err);
        }
        else {
          this.getErr_count = JSON.stringify(err);

        } if (this.getErr_count != "") {
          setTimeout(() => {
            this.getErr_count = "";
          }, 8000)
        }

      })

    }
    else { this.billingvalue = 0 }
  }
  //================================get group payor service=======================//
  grouppayorService(id, dta: boolean) {
    if (id.payerId != undefined && id.payerId != null) {
      let params = new URLSearchParams();
      params.append("payorId", id.payerId.toString());
      let url = "api/ClientAuthorization/GetServicedropdown?";
      this.CommonAPI.GetFunctionwithResponseTypeJson(params,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.grouppayorServiceArray = data;
        this.grouppayorServiceArray.forEach(element => {
          element.Value = element.masterservice.toString();
          element.Key = element.id.toString();
        })
        this.grouppayorServiceArray1 = data;
        this.grouppayorServiceArray1.forEach(element => {
          element.Value = element.masterservice.toString();
          element.Key = element.id.toString();
        })
        id.grouppayorServiceArray = this.grouppayorServiceArray;
        if (dta == true) {
          id.payerServiceMapId = null;
          id.serviceDescription = null;
          id.authLimitType = null;
        }
      }, (err: any) => {
        id.authLimitType = null;
        id.grouppayorServiceArray = null; id.payerServiceMapId = null; id.serviceDescription = null
        if (err.error.errors) {
          this.getErr_count = JSON.stringify(err.error.errors);
        }
        else {
          this.getErr_count = JSON.stringify(err.error);

        } if (this.getErr_count != "") {
          setTimeout(() => {
            this.getErr_count = "";
          }, 8000)
        }

      })

    }
    else { id.grouppayorServiceArray = null; id.payerServiceMapId = null; id.serviceDescription = null, id.authLimitType = null; }


  }
  //================================get payor list=============================//
  getPayorList() {
    let url = "api/Payer/CommonGetGPList?";
    this.CommonAPI.GetFunctionwithResponseTypeJson("",url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any = []) => {
      this.payorList = data;
      this.payorList.forEach(element => {
        element.Value = element.Value;
        element.Key = element.Key.toString();
      })
    },
      err => {

      })
  }
  //=====================================change date===========================//
  onDateChangedCareAUTHEND(i, event: IMyDateModel) {
    this.serviceinbox[i].endDate = event.formatted;

  }
  CareAUTHENDDatechange(i, event: IMyInputFieldChanged) {
    let value = event.value;

    if (value.length == 5 && value.substring(2, 3) != '/') {

      this.serviceinbox[i].endDate = value.substring(0, 2) + '/' + value.substring(2, 4) + '/' + value.substring(4, 10);
    }
  }
  onDateChangedCareAUTHStart(i, event: IMyDateModel) {
    this.serviceinbox[i].startDate = event.formatted;

  }
  CareAUTHStartDatechange(i, event: IMyInputFieldChanged) {
    let value = event.value;

    if (value.length == 5 && value.substring(2, 3) != '/') {

      this.serviceinbox[i].startDate = value.substring(0, 2) + '/' + value.substring(2, 4) + '/' + value.substring(4, 10);
    }
  }
  onDateChangedCareUpdateAUTHStart(event: IMyDateModel) {

    this.updateAuthList.startDate = event.formatted;

  }
  UpdateAUTHStartDatechange(event: IMyInputFieldChanged) {

    let value = event.value;
    if (value.length == 5 && value.substring(2, 3) != '/') {

      this.updateAuthList.startDate = value.substring(0, 2) + '/' + value.substring(2, 4) + '/' + value.substring(4, 10);
    }
  }
  onDateChangedUpdateAUTHENd(event: IMyDateModel) {

    this.updateAuthList.endDate = event.formatted;

  }
  UpdateAUTHENDchange(event: IMyInputFieldChanged) {

    let value = event.value;

    if (value.length == 5 && value.substring(2, 3) != '/') {

      this.updateAuthList.endDate = value.substring(0, 2) + '/' + value.substring(2, 4) + '/' + value.substring(4, 10);
    }
  }
  //=========================================getcompany list=============================//
  getCompanyList() {
    let url = "api/Company/CommonGetCompanyList?";
    this.CommonAPI.GetFunctionwithResponseTypeJson("",url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any = []) => {
      this.companyList = data;
      this.companyList.forEach(element => {
        element.label = element.Value;
        element.value = element.Key.toString();
      })
    },
      err => {

      })
  }
  //==========================================Close dialog=============================//
  Closedialog() {
    document.getElementById("modelopen").click();
    this.DataFromAuthorizationList = new EditDetailsAuthorization();
  }
  //===============================Save Authorization=====================================//
  checkValidation(authList: any = []) {
    this.loadingAuthadd = true;
    this.saveAuthErr = "";
    authList.forEach(element => {
      if (this.saveAuthErr == "") {
        if (element.startDate == null) {
          this.loadingAuthadd = false;
          this.saveAuthErr = "Please select start date to proceed";
        }
        else if (element.endDate == null) {
          this.loadingAuthadd = false;
          this.saveAuthErr = "Please select end date to proceed";
        }
        else if (element.payerServiceMapId == null) {
          this.loadingAuthadd = false;
          this.saveAuthErr = "Please select service to proceed";
        }
        else if (element.totalUnits == null) {
          this.loadingAuthadd = false;
          this.saveAuthErr = "Please enter total units to proceed";
        }
        else if (new Date(element.startDate).getTime() > new Date(element.endDate).getTime()) {
          this.loadingAuthadd = false;
          element.unitperday = " ";
          this.saveAuthErr = "End date must be larger than start date";
        }
        else if (element.insuranceNo == null) {
          this.loadingAuthadd = false;
          this.saveAuthErr = "Please enter insurance number to proceed";
        }
        else if (!element.insuranceNo || element.insuranceNo.trim().length < 2) {
           this.loadingAuthadd = false;
           this.saveAuthErr = "Insurance number must be at least 2 digits";
}
      }
    });
    if (this.saveAuthErr == "") {
      this.saveClientAuth(authList);
    }
  }
  /////////////////////////////////////////save client Authorization////////////////////////////////////////
  saveClientAuth(authList) {
    let val = JSON.parse(JSON.stringify(authList));
    val.forEach(element => {
      element.clientId = element.clientId.toString();
      element.startDate = element.startDate != null ? this.global.getDateTimeString(element.startDate) : "";
      element.endDate = element.endDate != null ? this.global.getDateTimeString(element.endDate) : "";
      element.serviceDescription = element.serviceDescription;
      element.companyId = element.companyId != null ? element.companyId : null;
      element.payerId = element.payerId != null ?element.payerId: null;
      element.payerServiceMapId = element.payerServiceMapId != null ? element.payerServiceMapId: null;
      element.totalUnits = element.totalUnits != null ? parseInt(element.totalUnits.toString()) : null;
      element.serviceAgreementNo = element.serviceAgreementNo;
      element.insuranceNo = element.insuranceNo;
      element.netRate = element.netRate != null ? parseFloat(element.netRate) : null;
      element.ucRate = element.ucRate != null ? parseFloat(element.ucRate) : null;
      element.DisableAuthorization = element.DisableAuthorization == true ? true : false;
      element.masterserviceId = element.masterserviceId != null ? element.masterserviceId : null;
    });
    let url = "api/ClientAuthorization/SaveClientAuthorization";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(val, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any = []) => {
      this.toastrService.success('Client Authorization created successfully!');
      setTimeout(() => {
        this.toastrService.clear();
      }, 8000);
      this.loadingAuthadd=false;
      document.getElementById("modelopen").click();
      this.back();
    },
      (err: any) => {
        this.loadingAuthadd=false;
        this.saveAuthErr = err;
      });
  }
  //////////////////////////////////////////update Client Authorization//////////////////////////////////////////////////
  updateClientAuth(authList) {
    this.loadingAuthadd=true;
    if (new Date(authList.startDate).getTime() > new Date(authList.endDate).getTime()) {
      this.loadingAuthadd = false;
      authList.unitperday = " ";
      this.saveAuthErr = "End date must be larger than start date";
      this.loadingAuthadd=false;
      return
    }
    let val = JSON.parse(JSON.stringify(authList));
    val.id = val.id;
    val.clientId =val.clientId;
    val.startDate = val.startDate != null ? this.global.getDateTimeString(val.startDate) : "";
    val.endDate = val.endDate != null ? this.global.getDateTimeString(val.endDate) : "";
    val.serviceDescription = val.serviceDescription;
    val.companyId = val.companyId != null ? val.companyId : null;
    val.payerId = val.payerId != null ? val.payerId: null;
    val.payerServiceMapId = val.payerServiceMapId != null ? val.payerServiceMapId: null;
    val.totalUnits = val.totalUnits != null ? parseInt(val.totalUnits.toString()) : null;
    val.serviceAgreementNo = val.serviceAgreementNo;
    val.insuranceNo = val.insuranceNo;
    val.netRate = val.netRate != null ? parseFloat(val.netRate) : null;
    val.ucRate = val.ucRate != null ? parseFloat(val.ucRate) : null;
    // val.previouslyUsedUnit = val.previouslyUsedUnit != null ? parseFloat(val.previouslyUsedUnit) : null;

    val.DisableAuthorization = val.DisableAuthorization == true ? true : false
    val.masterserviceId = this.updateAuthList.masterserviceId;
    let url = "api/ClientAuthorization/UpdateClientAuthorization";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(val,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any = []) => {
      this.masterserviceId = null;
      this.loadingAuthadd=false;
      this.toastrService.success('Client Authorization updated successfully!');
      setTimeout(() => {
        this.toastrService.clear();
      }, 8000);
      document.getElementById("editmodelopen").click();
      this.back();
    },
      (err: any) => {
        this.loadingAuthadd=false;
        this.saveAuthErr = err;
        this.toastrService.error(err)
      });
  }
  //////////////////////////////////////Back function///////////////////////////////////////////////////////////////////////
  back() {
    this.EventToEditAuth.emit({
      isView: true,
      isEdit: false,
      isEditAuthorization: false,
      AuthorizationId: "00000000-0000-0000-0000-000000000000",
      // state:this.DataFromAuthorizationList.state,
      AuthorizationData: this.DataFromAuthorizationList.AuthorizationData,
      ClientId: this.global.clientId,
      type: ''
    })
  }
  //////////////////////////////caluclate hours////////////////////////////////////////////////////////
  calculatetotalhour1(start, end, unit, billingvalue) {

    if (start != null && end != null && unit != null) {
      if (billingvalue != 0) {
        let diffDays = (Math.abs(new Date(end).getTime() - new Date(start).getTime()) / (1000 * 60 * 60 * 24)) + 1;
        let units = unit / diffDays;
        let val = (units / billingvalue).toFixed(3).toString();
        let val2 = val.split('.');
        if (val2.length == 1) {
          this.updateAuthList.totalUnitsperday = val2[0] + " hr " + "0 Min";
        }
        else {
          let vals2 = 0 + "." + val2[val2.length - 1];
          this.updateAuthList.totalUnitsperday = val2[0] + " hr " + (parseFloat(vals2) * 60).toString().split('.')[0] + "Min";
          // if (parseFloat(vals2) < 0.25) {
          //   this.updateAuthList.totalUnitsperday = val2[0] + " hr " + "0 Min";
          // } else if (parseFloat(vals2) < 0.50) {
          //   this.updateAuthList.totalUnitsperday = val2[0] + " hr " + "15 Min";
          // } else if (parseFloat(vals2) < 0.75) {
          //   this.updateAuthList.totalUnitsperday = val2[0] + " hr " + "30 Min";
          // } else if (parseFloat(vals2) >= 0.75) {
          //   this.updateAuthList.totalUnitsperday = val2[0] + " hr " + "45 Min";
          // }

        }
      }
      else {
        this.updateAuthList.totalUnitsperday = "0" + " hr " + "0 Min";
      }

      //this.serviceinbox[i].unitperday=(units/4).toFixed(2);

    }
  }
  ///////////////////////delete Authorization//////////////////////////////////////////////////////////////
  deleteAuth() {
    let params = new URLSearchParams();
    params.append("Id", this.DataFromAuthorizationList.AuthorizationId.toString());
    let url = "api/ClientAuthorization/DeleteClientAuthorization?";
    this.CommonAPI.DeleteFunctionForDeleteHttp(params,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.toastrService.success('Client Authorization deleted successfully!');
      setTimeout(() => {
        this.toastrService.clear();
      }, 8000);

      this.back();
    },
      (err: any) => {
        this.toastrService.error(err, 'error');
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
        this.back();
      }
    );
  }
  cleardata(i) {
    this.serviceObjList = {
      id: "00000000-0000-0000-0000-000000000000",
      clientId: this.global.clientId,
      startDate: null,
      endDate: null,
      companyId: null,
      isAdd: false,
      payerId: null,
      insuranceNo: null,
      serviceAgreementNo: null,
      payerServiceMapId: null,
      serviceDescription: null,
      authLimitType: null,
      totalUnits: null,
      unitsUsed: null,
      unitsRemaining: null,
      billingvalue: null,
      DisableAuthorization: null,
      grouppayorServiceArray: [],
      masterserviceId: null
    }


    this.serviceinbox[i] = this.serviceObjList;
    if (i >= 0) {
      this.serviceinbox[i].isAdd = false;

      if (i == (this.serviceinbox.length - 1)) {
        this.serviceinbox[i].isAdd = true;
      }
    }
  }
  allowonlynum(e) {
    if (
      // Allow: navigation keys: backspace, delete, arrows etc.
      (e.key === 'a' && e.ctrlKey === true) || // Allow: Ctrl+A
      (e.key === 'c' && e.ctrlKey === true) || // Allow: Ctrl+C
      (e.key === 'v' && e.ctrlKey === true) || // Allow: Ctrl+V
      (e.key === 'x' && e.ctrlKey === true) || // Allow: Ctrl+X
      (e.key === 'a' && e.metaKey === true) || // Allow: Cmd+A (Mac)
      (e.key === 'c' && e.metaKey === true) || // Allow: Cmd+C (Mac)
      (e.key === 'v' && e.metaKey === true) || // Allow: Cmd+V (Mac)
      (e.key === 'x' && e.metaKey === true) // Allow: Cmd+X (Mac)
    ) {
      // let it happen, don't do anything
      return;
    }
    // Ensure that it is a number and stop the keypress
    if (
      (e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) &&
      (e.keyCode < 96 || e.keyCode > 105)
    ) {
      e.preventDefault();
    }
  }
  dataEmitfromChild(event: IsViewEditSchedule) {
    this.ViewEdit = event;
    this.isEdit = event.isEdit;
    this.isAdd = event.isAdd;
    this.ViewEdit.AgencyId = this.global.globalAgencyId;
    this.ViewEdit.ClientId = this.global.clientId;
    this.EventToEditAuth.emit({
      isView: true,
      isEdit: false,
      isEditAuthorization: false,
      AuthorizationId: "00000000-0000-0000-0000-000000000000",
      // state:this.DataFromAuthorizationList.state,
      AuthorizationData: this.DataFromAuthorizationList.AuthorizationData,
      ClientId: this.global.clientId,
      type: ''
    })
    document.getElementById('frequency').click();

    // this.AgencyId = event.CompanyData.agencyId;
    // this.isViewEdit.emit({ isView: false, isEdit: true, isEditCompany: false, editCompanyId: 0,AgencyId:this.ViewEdit.AgencyId, CompanyData: list })



  }
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}